//  枚举类型-必须与后端列表顺序一致
export const TypeEnum = {
  // 有电车不走
  haveElecWhileStop: '8',
  // 坐垫
  cushion: '1',
  // 车轮
  wheel: '2',
  // 链条
  chain: '3',
  // 脚撑
  kickstand: '4',
  // 刹车
  brake: '5',
  // 车头
  head: '6',
  // 脚踏
  pedal: '7',
  // 其他
  other: '99',
  // 车速失控
  outOfControl: '9',
};

// 布局 枚举
export const LayoutEnum = {
  // 上部分
  top: 1,
  // 下部分
  bottom: 2,
};

// 上部分 报障
export const TopList = [
  TypeEnum.cushion,
  TypeEnum.wheel,
  TypeEnum.chain,
  TypeEnum.kickstand,
  TypeEnum.brake,
  TypeEnum.head,
  TypeEnum.pedal,
];

// 图片故障部位
export const partListLabelMap = {
  [TypeEnum.haveElecWhileStop]: {
    label: '有电车不走',
    key: 'haveElecWhileStop',
    uniqueness: TypeEnum.haveElecWhileStop,
    reverse: true,
  },
  [TypeEnum.cushion]: {
    label: '坐垫',
    key: 'cushion',
    uniqueness: TypeEnum.cushion,
    reverse: true,
  },
  [TypeEnum.wheel]: {
    label: '车轮',
    key: 'wheel',
    uniqueness: TypeEnum.wheel,
    reverse: true,
  },
  [TypeEnum.chain]: {
    label: '链条',
    key: 'chain',
    uniqueness: TypeEnum.chain,
    reverse: true,
  },
  [TypeEnum.kickstand]: {
    label: '脚撑',
    key: 'kickstand',
    uniqueness: TypeEnum.kickstand,
    reverse: true,
  },
  [TypeEnum.brake]: {
    label: '刹车',
    key: 'brake',
    uniqueness: TypeEnum.brake,
    reverse: false,
  },
  [TypeEnum.head]: {
    label: '车头',
    key: 'head',
    uniqueness: TypeEnum.head,
    reverse: false,
  },
  [TypeEnum.pedal]: {
    label: '脚踏',
    key: 'pedal',
    uniqueness: TypeEnum.pedal,
    reverse: false,
  },
  [TypeEnum.other]: {
    label: '其他',
    key: 'other',
    uniqueness: TypeEnum.other,
    reverse: true,
  },
  [TypeEnum.outOfControl]: {
    label: '车速失控',
    key: 'outOfControl',
    uniqueness: TypeEnum.outOfControl,
    reverse: true,
  },
};

export const PAGE_TYPE = {
  BEFORE_RIDE: 0,
  RIDING: 1,
  PAYMENT: 2,
  FINISH_RIDE: 3,
  SHORT_TIME: 4,
};

export const BROKEN_TYPE = {
  BIKE_BREAKDOWN: 3,
  OTHERS: 5,
};

export const UPLOAD_IMG_SCENE = {
  UPLOAD_SCENE: 1,
};
